module.exports = __webpack_public_path__ + "img/4s.61b039a1.png";